// Tab state for the app. Plain mutable object; modules mutate it then call render().
import { get } from "../shared/settings-store.js";

export const state = {
	tabs: [],
	activeId: 1,
	next: 2,
	books: null, // loaded game library (folders.js)
	apps: null, // loaded app launcher list (folders.js)
	partners: null, // loaded partners list (folders.js)
	closed: [], // recently-closed tabs (reopen stack)
	dragId: null,
	editing: false, // true while the user is typing in the address bar
};

export function blankTab(id) {
	return {
		id,
		title: "New Tab",
		addr: "",
		url: "",
		hist: [],
		hi: -1,
		src: "", // proxied iframe src (random-prefixed proxy path)
		internal: null, // same-origin internal page (e.g. /settings) loaded directly
		loading: false,
		view: null, // folder view: books | worksheets | tools | bookmarks | history
		zoom: Number(get("defaultZoom")) || 100, // per-tab page zoom (%)
		blank: false, // true = empty tab (newTab setting "blank"), no dashboard
		skipLoader: false, // user dismissed the loading overlay for this navigation
		suspended: false, // iframe dropped to save resources (reloads when reopened)
		pinned: false, // pinned tab: no close button, resists Ctrl-W / close-others
		restore: null, // pending session-restore target { kind, target } (lazy-loads on select)
		error: null, // { title, message, kind } when a proxied load fails
		favicon: null, // resolved same-origin (proxied) favicon URL - proxied tabs only
		priv: false, // visited a page in incognito: never saved for "Restore tabs"
	};
}

export function active() {
	return state.tabs.find((t) => t.id === state.activeId);
}
export function byId(id) {
	return state.tabs.find((t) => t.id === id);
}

state.tabs = [blankTab(1)];
